import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/BlogPost.css";
import "../styles/Blog4.css";

function BlogPost12() {
  return (
    <>
      <Navbar />

      <article className="blog-post">

                {/* ── Breadcrumb ── */}
        <p className="blog-breadcrumb">
          <span>Life & Technology</span>
          <span className="breadcrumb-divider">|</span>
          <span className="breadcrumb-section">Mindset | Tennis | Artificial Intelligence</span>
        </p>

        {/* ── Headline & dek ── */}
        <h1 className="blog-headline">
          What Your Tennis Coach Would Want You to Know About AI: Tennis, Artificial Intelligence, and how the two relate
        </h1>

        <p className="blog-dek">
          From resetting after a bad point at the US Open to resetting your trust in an AI answer. Going through how sport makes us better workers, AI Operating Rules for Today,
        </p>

        {/* ── Video Embed ── */}
        <div
          className="blog-video-embed"
          style={{
            position: "relative",
            width: "100%",
            maxWidth: "360px",
            aspectRatio: "9 / 16",
            margin: "0 auto 24px",
          }}
        >
          <iframe
            src="https://www.youtube.com/embed/VcaVPt8y_pQ"
            title="YouTube video player"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              border: 0,
            }}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>

        {/* ── Share row ── */}
        <div className="blog-meta-row">
          <button
            className="blog-share-btn"
            onClick={() =>
              navigator.share?.({ title: document.title, url: window.location.href })
            }
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="18" cy="5" r="3" />
              <circle cx="6" cy="12" r="3" />
              <circle cx="18" cy="19" r="3" />
              <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
              <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
            </svg>
            Share
          </button>
        </div>

        {/* ── Date + read time ── */}
        <p className="blog-dateline">September 1st 2026 &nbsp;|&nbsp; 9 min read</p>

        {/* ── Body copy ── */}
        <div className="blog-body">

          <p className="blog-drop-cap">
            Here to wish you a Happy September! For Cyber people, September
            = Fall Cyber Club gets revamped and stood back up. For Tennis
            people, September = US Open. For people who don't like cyber
            or tennis, well, cyber and tennis skills can translate to our
            everyday lives and work. In this newsletter, we break down the
            power of rituals and how you can start working your own.
          </p>

          <h2 className="blog-section-heading">
            Part One: What Tennis Teaches You About Handling Change
          </h2>

          <p>
            Right now, the 2026 US Open is in flight at Flushing Meadows.
            Matches are underway across the grounds, seeds are already
            dropping, and by the time the trophies are lifted in
            mid-September, a few players will have won not because they
            hit the hardest ball, but because they handled the worst
            moments of a match better than the person across the net.
          </p>

          <p>
            That skill = Having a ritual. Staying composed when a point, a
            set, or an entire match starts slipping away is one of the
            most transferable things tennis teaches.
          </p>

          <p>
            Watch closely between points at any high-level match and
            you'll see the same small ritual repeated over and over:
            respond, relax, prepare for the next point, refocus. That
            routine isn't superstition. It's a deliberate response and
            relaxation technique. It is a way of resetting the nervous
            system after a missed shot or just some bad luck. That way,
            the next point is played on its own terms instead of as an
            emotional reaction to the last one. Players who skip that
            reset tend to spiral: one dropped game becomes three, one bad
            break colors an entire set.
          </p>

          <h3 className="blog-subsection-heading">
            The skill isn't confidence — it's the reset
          </h3>

          <p>
            It's tempting to think elite competitors are simply more
            confident than everyone else. What's actually being trained,
            year after year on a practice court, is narrower and more
            useful than confidence. This is the ability to notice you're
            rattled, take a breath, and respond to what's actually in
            front of you rather than react to what just happened. The
            point in front of you is the only one that exists. Your ritual
            helps you get there.
          </p>

          <h3 className="blog-subsection-heading">
            Why this belongs in the workforce conversation
          </h3>

          <p>
            That same mental skill maps almost exactly onto how people
            cope with change and unprecedented events at work. For
            example: A reorganization is announced. A tool your whole team
            relied on gets replaced overnight. A project you'd planned for
            months gets shelved by a decision made three floors above you.
          </p>

          <p>
            The instinct, just like on a tennis court after some bad luck,
            is to let that one disruptive moment define everything that
            comes after it. To spiral rather than reset.
          </p>

          <p>
            The players who handle unpredictability best, on court and in
            a career, tend to share the same habit: they build in a
            deliberate pause before responding. That defined their ritual.
          </p>

          <p>
            What does this ritual look like? Breathe, assess what's
            actually true right now, and play the point in front of you.
            In work this is the meeting, the email, the decision. It's a
            small, learnable skill, in offices as much as on Arthur Ashe
            Stadium.
          </p>

          <h2 className="blog-section-heading">
            Part Two: Why "Confidently Wrong" Is the Most Important Phrase in AI Today
          </h2>

          <p>
            Ask most people what comes to mind when they hear "AI," and
            you'll get some blend of four things: automation (it's going
            to do my job for me), efficiency (it's going to do my job
            faster), fear (it's going to take my job), and change (nothing
            is going to look the same). All four reactions are reasonable.
            All four are also incomplete, because they focus on what AI
            does rather than on how it actually knows things. That gap is
            where most of the real risk lives.
          </p>

          <p>
            Before any of us can use AI responsibly, we have to understand
            one uncomfortable fact: these models can be wrong with the
            exact same confidence they're right.
          </p>

          <p>
            There's no built-in tone of hesitation when a model is
            guessing. It doesn't stammer. It doesn't hedge unless it's
            been prompted to. It just answers, smoothly, fluently, and
            sometimes incorrectly.
          </p>

          <h3 className="blog-subsection-heading">
            Why models are confidently wrong
          </h3>

          <p>
            Large language models generate answers primarily from
            parametric memory which is patterns and associations baked
            into their weights during training, not a live lookup of
            facts. Think of it like someone recalling a conversation from
            years ago: the shape of the memory is there, the general gist
            is often right, but the specific details can be reconstructed,
            blended, or invented without the person even realizing it.
          </p>

          <p>This is why a model can:</p>

          <ul className="blog-list">
            <li>Cite a statistic that sounds precise but doesn't exist</li>
            <li>Describe a legal case, study, or event with total fluency and zero grounding</li>
            <li>Blend two similar facts into one plausible-but-wrong answer</li>
            <li>Answer a question about today using patterns learned from some point in the past</li>
          </ul>

          <p>
            None of this is malicious. It's a structural feature of how
            these systems generate language: they're optimized to produce
            a plausible next answer, not to flag their own uncertainty.
            That's what makes "confidently wrong" so dangerous. The
            writing quality of a wrong answer is often indistinguishable
            from the writing quality of a right one.
          </p>

          <h3 className="blog-subsection-heading">
            Three rules for using AI today
          </h3>

          <p>
            Given that reality, here are three operating rules worth
            adopting before you rely on AI output for anything that
            matters.
          </p>

          <p>
            <strong>1. Ask "what's the harm if this is wrong?" first</strong>
            <br />
            Before you act on an AI-generated answer, pause and ask what
            happens if the information is incorrect. A wrong answer to
            "give me three metaphor ideas for a poem" costs you nothing. A
            wrong answer to "what's the maximum dosage" or "does this
            contract clause protect us" could cost a lot. Let the
            potential downside — not the model's confidence — determine
            how much verification you do.
          </p>

          <p>
            <strong>2. Tie every claim to a source — or label it unsupported</strong>
            <br />
            If a claim doesn't have a traceable source, that should be
            stated explicitly, not left ambiguous. "According to [source],
            X is true" is a fundamentally different sentence than "X is
            true" with no attribution. When you're using AI output in a
            report, email, or decision, make it a habit to ask the model
            directly: where did this come from? If it can't give you a
            real, checkable source, label the claim as unsupported rather
            than letting it read as fact.
          </p>

          <p>
            <strong>3. Keep sensitive data out of unapproved tools</strong>
            <br />
            Not every AI tool has the same data handling, retention, or
            security posture. Before pasting in customer records, internal
            financials, source code, or anything else sensitive, know
            whether that tool is actually approved for that data — by your
            organization's policy, not just by convenience. "It was faster
            to paste it in" is not a data governance policy.
          </p>

          <h3 className="blog-subsection-heading">
            Why grounding matters
          </h3>

          <p>
            This is where grounding comes in — the practice of anchoring
            an AI's output to real, verifiable, current information rather
            than letting it answer purely from memory. Grounding is the
            antidote to "confidently wrong," because it shifts the model
            from recalling to checking.
          </p>

          <p>
            A grounded answer says, in effect: "Here's what a specific,
            retrievable source says," rather than "here's what
            pattern-matching against my training data suggests." The
            difference matters most exactly when the stakes are highest —
            current events, specific numbers, legal or medical specifics,
            anything time-sensitive, and anything you plan to act on.
          </p>

          <h3 className="blog-subsection-heading">
            A step-by-step guide to grounding your AI use
          </h3>

          <ol className="blog-list">
            <li>
              Identify claims that need grounding. Not every sentence
              needs a citation — but numbers, dates, named sources,
              quotes, current events, and anything you'll repeat as fact
              do.
            </li>
            <li>
              Ask the model to search or cite, don't assume it already
              did. If the tool has web search, document retrieval, or a
              knowledge base connector, explicitly invoke it or confirm it
              was used. Don't assume a fluent answer means a grounded one.
            </li>
            <li>
              Request the source alongside the claim. Ask for the specific
              source — a URL, document name, or citation — not just
              "where did you learn this," which invites another
              parametric guess.
            </li>
            <li>
              Verify the source actually says what's claimed. Models can
              cite a real source and still summarize it inaccurately. A
              source existing isn't the same as the source supporting the
              claim as stated.
            </li>
            <li>
              Flag anything that stays unsourced. If no source can be
              produced, don't quietly let the claim stand — label it
              explicitly as an assumption, an estimate, or an unsupported
              claim.
            </li>
            <li>
              Match your verification effort to the harm rule. For
              low-stakes creative or exploratory work, light verification
              is fine. For anything with real consequences — financial,
              medical, legal, safety-related — verify independently before
              acting.
            </li>
            <li>
              Re-ground anything time-sensitive. "Current" information
              ages. A grounded answer from three weeks ago about a
              fast-moving topic may already be stale; re-check rather than
              reuse.
            </li>
          </ol>

          <h2 className="blog-section-heading">
            The bigger picture
          </h2>

          <p>
            AI isn't going to stop being automation, efficiency, fear, and
            change wrapped into one intimidating package. In my opinion,
            that framing isn't wrong, but it's just the surface level. The
            deeper, more useful framing is this: AI is a tool that
            generates fluent language whether or not it actually knows the
            answer. Your job isn't to distrust it wholesale. It isn't to
            trust it blindly either. It's to build the habit of asking
            what's at stake, demanding a source, protecting sensitive
            data, and grounding anything that matters. Do this every
            single time. Repeat it like a tennis ritual.
          </p>

          <p className="blog-takeaway">
            <strong>Takeaway:</strong> Revisit how you use AI. Do you have
            a ritual to evaluate your AI outcomes? If not, try the 7 step,
            step-by-step listed above. If you want a templated version of these rules, let me know at alexisbernthal4@gmail.com and I'll send you the template I created (for free because we're all cyber club people).
            Reach out if you have any questions
            or thoughts. Information in the footer. A big thanks as always
            :)
          </p>

        </div>
      </article>

      <Footer />
    </>
  );
}

export default BlogPost12;